import { render, staticRenderFns } from "./Tema2.vue?vue&type=template&id=3a1ea190&scoped=true&lang=pug&"
import script from "./Tema2.vue?vue&type=script&lang=js&"
export * from "./Tema2.vue?vue&type=script&lang=js&"
import style0 from "./Tema2.vue?vue&type=style&index=0&id=3a1ea190&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1ea190",
  null
  
)

export default component.exports